/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationRemediateRequest extends models.ScheduleRecommendationActionBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationRemediateRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationRemediateRequest>): ScheduleRecommendationRemediateRequest {
        let obj = Object.assign(new ScheduleRecommendationRemediateRequest(), model);
        ScheduleRecommendationRemediateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationRemediateRequest>): ScheduleRecommendationRemediateRequest {
        if (!model) return null;
        return ScheduleRecommendationRemediateRequest.newInstance(<ScheduleRecommendationRemediateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationRemediateRequest) {
        if (!obj) return;

        models.ScheduleRecommendationRemediateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationRemediateRequest): boolean {
        if (models.ScheduleRecommendationActionBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationRemediateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (typeof this.end_time === "string") {
            this.end_time = new Date(<string><any>this.end_time);
        }
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    /**
     * Unique Resource Id of Inventory
     */
    resource_id: string;

    /**
     * Email addresses to notify
     */
    emails: Array<string>;

    day: models.DayOfWeek;

    /**
     * Schedule Start Time
     */
    start_time: Date;

    /**
     * Schedule End Time
     */
    end_time: Date;

}
